import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Text,
  UseDisclosureReturn,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import {
  SUBSCRIPTION_UPDATE_DELAY,
  useMutationUpdateAccountAccess,
} from "../../../store/useMutationUpdateAccountAccess";
import { ConfirmActionModal } from "../../modals/ConfirmActionModal";

export function RemoveBillingOwnerModal({
  accountId,
  billingOwnerId,
  disclosure,
}: {
  accountId: string;
  billingOwnerId: string;
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const mutationUpdateAccountAccess = useMutationUpdateAccountAccess(accountId);

  const removeBillingOwner = async () => {
    await mutationUpdateAccountAccess.mutateAsync({
      ops: [
        {
          action: "delete",
          userId: billingOwnerId,
        },
      ],
    });

    await new Promise<void>((resolve) =>
      setTimeout(resolve, SUBSCRIPTION_UPDATE_DELAY),
    );
  };

  return (
    <ConfirmActionModal
      disclosure={disclosure}
      title="Remove billing owner"
      confirmButtonText="Remove billing owner"
      colorScheme="red"
      onConfirm={removeBillingOwner}
    >
      <VStack align="stretch" spacing={6}>
        <Text>
          You are removing the Billing Owner from the current account.
        </Text>

        <Alert status="warning" borderRadius="md" alignItems="flex-start">
          <AlertIcon />

          <VStack align="flex-start" spacing={2}>
            <AlertTitle>Warning</AlertTitle>

            <AlertDescription>
              This will immediately remove the billing owner’s access to the
              account and cancel the active subscription.
            </AlertDescription>

            <AlertDescription>
              Any remaining time on the plan will be permanently lost.
            </AlertDescription>

            <AlertDescription>
              To regain access to features, you’ll need to purchase a new
              subscription.
            </AlertDescription>
          </VStack>
        </Alert>
      </VStack>
    </ConfirmActionModal>
  );
}
